import { render, staticRenderFns } from "./addClassfiy.vue?vue&type=template&id=55f4323a&"
import script from "./addClassfiy.vue?vue&type=script&lang=js&"
export * from "./addClassfiy.vue?vue&type=script&lang=js&"
import style0 from "./addClassfiy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55f4323a')) {
      api.createRecord('55f4323a', component.options)
    } else {
      api.reload('55f4323a', component.options)
    }
    module.hot.accept("./addClassfiy.vue?vue&type=template&id=55f4323a&", function () {
      api.rerender('55f4323a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/components/addClassfiy.vue"
export default component.exports